module.exports = __webpack_public_path__ + "img/gallery_icon.32a650d3.svg";